module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_c('label', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (['artist', 'label', 'brand'].indexOf(_vm.user.user_type) > -1) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('h3', [_vm._v("Open Case / File complaint")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ticket_reason_dropdown",
    attrs: {
      "items": _vm.ticket_reasons,
      "name": "ticket_reason",
      "disabled": _vm.hasTicket,
      "placeholder": "Select reason for opening case...",
      "autocomplete": ""
    },
    model: {
      value: (_vm.ticket.reason),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "reason", $$v)
      },
      expression: "ticket.reason"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticket.description),
      expression: "ticket.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023'),
      expression: "'required|max:1023'"
    }],
    staticClass: "mt-2",
    attrs: {
      "name": "ticket_description",
      "placeholder": "Write a message...",
      "disabled": _vm.hasTicket
    },
    domProps: {
      "value": (_vm.ticket.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ticket, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.hasTicket) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "small": "",
      "round": "",
      "color": "green",
      "disabled": !_vm.canSend
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendTicket()
      }
    }
  }, [_vm._v("Send")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-5": "",
      "pt-3": "",
      "text-xs-center": ""
    }
  }, [_c('p', {
    staticClass: "ma-0"
  }, [_vm._v("\n          Any disputes regarding refunds & returns can only be resolved between sellers and buyers.\n          If we discover a seller has a trend of violations, we may close their account.\n          "), _c('br'), _c('br')])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "px-3": "",
      "border-left": ""
    }
  }, [_c('div', {
    staticClass: "product-cover",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "product-name": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.name) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc58a15","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/components/ticket_new_dialog.vue
// module id = 1794
// module chunks = 180